import { ANSWER_MESSAGE, OrdenExpressGetUserCredentials, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';

const REQUEST_SAVE_ORDER_BEGINING = 'REQUEST_SAVE_ORDER_BEGINING';
export const requestSaveOrderBegining = (requestSaveOrderBegining) => (
  {
    type: REQUEST_SAVE_ORDER_BEGINING,
    requestSaveOrderBegining
  }
);
export const RESPONSE_SAVE_ORDER_BEGINING = 'RESPONSE_SAVE_ORDER_BEGINING';
const responseSaveOrderBegining = responseSaveOrderBegining => (
  {
    type: RESPONSE_SAVE_ORDER_BEGINING,
    responseSaveOrderBegining
  }
);
export const fromServerSaveOrderBegining = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_ORDER_BEGINING),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/order/saveBegining', action.requestSaveOrderBegining, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveOrderBegining(OrdenExpressValidateSecurityForAnswer(response.response, action$, state$))),
      catchError(error => of(responseSaveOrderBegining(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_GET_DELIVERY_DATES = 'REQUEST_GET_DELIVERY_DATES';
export const requestGetDeliveryDates = () => (
  {
    type: REQUEST_GET_DELIVERY_DATES
  }
);
export const RESPONSE_GET_DELIVERY_DATES = 'RESPONSE_GET_DELIVERY_DATES';
const responseGetDeliveryDates = responseGetDeliveryDates => (
  {
    type: RESPONSE_GET_DELIVERY_DATES,
    responseGetDeliveryDates
  }
);
export const fromServerGetDeliveryDates = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_DELIVERY_DATES),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/order/getDeliveryDate', OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetDeliveryDates(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetDeliveryDates(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_GET_ORDERS_REQUESTED = 'REQUEST_GET_ORDERS_REQUESTED';
export const requestGetOrdersRequested = (requestGetOrdersRequested) => (
  {
    type: REQUEST_GET_ORDERS_REQUESTED,
    requestGetOrdersRequested
  }
);
export const RESPONSE_GET_ORDERS_REQUESTED = 'RESPONSE_GET_ORDERS_REQUESTED';
const responseGetOrdersRequested = responseGetOrdersRequested => (
  {
    type: RESPONSE_GET_ORDERS_REQUESTED,
    responseGetOrdersRequested
  }
);
export const fromServerGetOrdersRequested = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_ORDERS_REQUESTED),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/order/getOrderRequested', action.requestGetOrdersRequested, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetOrdersRequested(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetOrdersRequested(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_SAVE_ORDER_STATE = 'REQUEST_SAVE_ORDER_STATE';
export const requestSaveOrderState = (requestSaveOrderState) => (
  {
    type: REQUEST_SAVE_ORDER_STATE,
    requestSaveOrderState
  }
);
export const RESPONSE_SAVE_ORDER_STATE = 'RESPONSE_SAVE_ORDER_STATE';
const responseSaveOrderState = responseSaveOrderState => (
  {
    type: RESPONSE_SAVE_ORDER_STATE,
    responseSaveOrderState
  }
);
export const fromServerSaveOrderState = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_ORDER_STATE),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/order/saveOrderUpdateState', action.requestSaveOrderState, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveOrderState(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveOrderState(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_GET_ORDER_REQUESTED_DETAIL = 'REQUEST_GET_ORDER_REQUESTED_DETAIL';
export const requestGetOrderRequestedDetail = (requestGetOrderRequestedDetail) => (
  {
    type: REQUEST_GET_ORDER_REQUESTED_DETAIL,
    requestGetOrderRequestedDetail
  }
);
export const RESPONSE_GET_ORDER_REQUESTED_DETAIL = 'RESPONSE_GET_ORDER_REQUESTED_DETAIL';
const responseGetOrderRequestedDetail = responseGetOrderRequestedDetail => (
  {
    type: RESPONSE_GET_ORDER_REQUESTED_DETAIL,
    responseGetOrderRequestedDetail
  }
);
export const fromServerResponseGetOrderRequestedDetail = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_ORDER_REQUESTED_DETAIL),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/order/getDetailOrder', action.requestGetOrderRequestedDetail, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetOrderRequestedDetail(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetOrderRequestedDetail(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_SAVE_ORDER_PRODUCT_DETAIL = 'REQUEST_SAVE_ORDER_PRODUCT_DETAIL';
export const requestSaveOrderProductDetail = (requestSaveOrderProductDetail) => (
  {
    type: REQUEST_SAVE_ORDER_PRODUCT_DETAIL,
    requestSaveOrderProductDetail
  }
);
export const RESPONSE_SAVE_ORDER_PRODUCT_DETAIL = 'RESPONSE_SAVE_ORDER_PRODUCT_DETAIL';
const responseSaveOrderProductDetail = responseSaveOrderProductDetail => (
  {
    type: RESPONSE_SAVE_ORDER_PRODUCT_DETAIL,
    responseSaveOrderProductDetail
  }
);

export const fromServerSaveOrderProduuctDetail = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_ORDER_PRODUCT_DETAIL),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/order/saveOrderDetailProduct', action.requestSaveOrderProductDetail, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveOrderProductDetail(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveOrderProductDetail(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_SEND_EMAIL_ORDER = 'REQUEST_SEND_EMAIL_ORDER';
export const requestSendEmailOrder = (idOrder) => (
  {
    type: REQUEST_SEND_EMAIL_ORDER,
    idOrder
  }
);
export const RESPONSE_SEND_EMAIL_ORDER = 'RESPONSE_SEND_EMAIL_ORDER';
const responseSendEmailOrder = responseSendEmailOrder => (
  {
    type: RESPONSE_SEND_EMAIL_ORDER,
    responseSendEmailOrder
  }
);
export const fromServerSendEmailOrder = (action$, state$) => action$.pipe(
  ofType(REQUEST_SEND_EMAIL_ORDER),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/order/sendEmailOrder/'+action.idOrder, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSendEmailOrder(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSendEmailOrder(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_RESET_STATE_ORDER = 'REQUEST_RESET_STATE_ORDER';
export const requestResetStateOrder = () => (
  {
    type: REQUEST_RESET_STATE_ORDER
  }
);

const REQUEST_DELETE_ORDER = 'REQUEST_DELETE_ORDER';
export const requestDeleteOrder = (idOrder) => (
  {
    type: REQUEST_DELETE_ORDER,
    idOrder
  }
);
export const RESPONSE_DELETE_ORDER = 'RESPONSE_DELETE_ORDER';
const responseDeleteOrder = responseDeleteOrder => (
  {
    type: RESPONSE_DELETE_ORDER,
    responseDeleteOrder
  }
);
export const fromServerDeleteOrder = (action$, state$) => action$.pipe(
  ofType(REQUEST_DELETE_ORDER),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/order/deleteOrder/'+action.idOrder, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseDeleteOrder(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseDeleteOrder(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export default this;